import { Container } from "@mui/material";
import bookingImg from "../../assets/images/home/booking.png";
import createGameImg from "../../assets/images/home/create-game.png";
import groupImg from "../../assets/images/home/group.png";
import inviteSent from "../../assets/images/home/invite-sent.png";
import playerListImg from "../../assets/images/home/player-list.png";
import topPlayers from "../../assets/images/home/top-players.png";
import waitingList from "../../assets/images/home/waiting-list.png";
import yourPayout from "../../assets/images/home/your-payout.png";
import { SEO, StructuredData } from "../../components/seo";
import {
  ORGANIZATION_SCHEMA,
  PAGE_SEO,
  WEBSITE_SCHEMA,
} from "../../constants/seo";
import {
  Comment,
  FeatureSection,
  Hero,
  HowItWorks,
  NextGame,
  Questions,
} from "./parts";

const Home = () => {
  // const { loading } = useAuth();

  // Redirect logged-in users to dashboard
  // useEffect(() => {
  //   if (!loading && currentUser) {
  // navigate("/dashboard", { replace: true });
  //   }
  // }, [currentUser, loading, navigate]);

  // Show loading while checking auth status
  // if (loading) {
  //   return (
  //     <Container>
  //       <Box
  //         sx={{
  //           display: "flex",
  //           justifyContent: "center",
  //           alignItems: "center",
  //           minHeight: "100vh",
  //         }}
  //       >
  //         <Text variant="paragraph3">Loading...</Text>
  //       </Box>
  //     </Container>
  //   );
  // }

  return (
    <>
      <SEO
        title={PAGE_SEO.HOME.title}
        description={PAGE_SEO.HOME.description}
        keywords={PAGE_SEO.HOME.keywords}
      />
      <StructuredData data={ORGANIZATION_SCHEMA} id="organization-schema" />
      <StructuredData data={WEBSITE_SCHEMA} id="website-schema" />
      <Hero />
      <Container id="about" maxWidth={"xl"} sx>
        <HowItWorks />
      </Container>
      <FeatureSection
        id="features"
        title="Last minute dropouts"
        subtitle="Save time. No more last-minute dropouts."
        description="Set recurring invites and we’ll handle the rest. Players get reminders, dropouts are automatically replaced from the waitlist, and your pitch stays packed every time."
        buttonText="Grow your community"
        imgSrc={createGameImg}
        toast={{
          imgSrc: inviteSent,
          position: "3%",
          width: { xs: "44vw", md: "22vw" },
        }}
      />
      <FeatureSection
        id="multi-sport"
        title="Multi sport"
        subtitle="Fill games faster. From 5-a-sides to Pick-up Basketball."
        description="Whether it’s football, basketball, or even ultimate frisbee, Findaside helps you post once and reach players fast. Hosts fill their spots in minutes, and players discover new games they can join with a tap. No chasing, just sport."
        buttonText="Launch your game"
        imgSrc={playerListImg}
        reverse
        toast={{
          imgSrc: waitingList,
          position: "9%",
          width: { xs: "32vw", md: "16vw" },
        }}
      />
      <FeatureSection
        id="payments"
        title="Automated payments & Reminders"
        subtitle="No more chasing players for cash."
        description="Choose whether players pay upfront when they book, so you’re never stuck collecting money on the pitch. We also send automatic reminders before the game, helping you cut down on no-shows and last-minute excuses."
        buttonText="Launch your game"
        imgSrc={bookingImg}
        toast={{
          imgSrc: yourPayout,
          position: "40%",
          width: { xs: "33vw", md: "16.5vw" },
        }}
      />
      <FeatureSection
        id="community"
        title="Community"
        subtitle="Build your community of regulars."
        description="Turn one-off players into a reliable squad. With recurring games, automatic reminders, and easy repeat bookings, Findaside helps you grow a steady group of regulars who keep your sessions full every week."
        buttonText="Launch your game"
        imgSrc={groupImg}
        reverse
        toast={{
          imgSrc: topPlayers,
          position: "6%",
          width: { xs: "27vw", md: "13.5vw" },
          right: "8%",
        }}
      />
      <Comment />
      <Questions />
      <NextGame />
    </>
  );
};

export default Home;
